import { useEffect, useState } from "react";
import { Checkbox, Input, toAbsoluteUrl } from "sr/helpers";
import { Link, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import { useFormik } from "formik";
import cleanerRegisterSchema from "sr/utils/schemas/cleaner/cleanerRegister";
import { cleanerRegister } from "sr/utils/api/cleaner/cleanerRegister";
import { useNavigate } from "react-router-dom";
import { sendOTP } from "sr/utils/api/sendOTP";
import { ButtonAuth } from "sr/helpers/ui-components/ButtonAuth";
import { login } from "sr/utils/api/login";
import { ReactDatePicker } from "sr/helpers/ui-components/ReactDatePicker";
import { useAuth } from "../module/auth";
import { InputNumberFormat } from "sr/helpers/functions/InputNumberFormat";
import { fetchContractor } from "sr/helpers/apiFunctions/contractor/fetchContractor";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { updateContractor } from "sr/utils/api/company/workorder/updateContractor";
import { CreateWallet } from "sr/utils/api/wallet/CreateWallet";
import { scrollToError } from "sr/helpers/functions/scrollToError";
import SmartSearchSelect from "sr/helpers/ui-components/SmartSearchSelect";
import { City } from "../component/types/city/City";
import { setRegionIdMe } from "sr/helpers/functions/setCityMe";
import { useSearchParams } from "react-router-dom";
import { format, set, subYears } from "date-fns";
import { RadioInput } from "sr/helpers/ui-components/RadioInput";
import { ReactSelect } from "sr/helpers/ui-components/ReactSelect";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { renderRequiredLabel } from "sr/utils/helper";
import { getNearbyRegions } from "sr/utils/api/region/getNearbyRegions";
import { toast } from "react-toastify";
import CheckBoxHandle from "sr/helpers/functions/CheckBoxHandle";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getCleaner } from "sr/utils/api/cleaner/getCleaner";
import { updateCleaner } from "sr/utils/api/cleaner/updateCleaner";
import { getUserFullProfile } from "sr/utils/api/user/user";

export default function RegisterCleaner({ targetProfile = false }: { targetProfile?: boolean }) {
  const intl = useIntl();
  const dobHelpText = intl.formatMessage({
    id: "AUTH.INPUT.DATEOFBIRTH.HELP",
    defaultMessage:
      "You must be at least 18 years old to work through JaniJobs.",
  });
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const { persistToken, setOnboardingStatus } = useAuth();
  const [id, setId] = useState<string>();
  const params = useParams();
  const [isContractorActive, setIsContractorActive] = useState(false);
  const [searchParams] = useSearchParams();
  const [code, setCode] = useState<string>();
  const [defaultDob] = useState<string>(() => {
    const today = new Date();
    const eighteenYearsAgo = subYears(today, 18);
    eighteenYearsAgo.setHours(0, 0, 0, 0);
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return format(
      eighteenYearsAgo,
      tz === "Asia/Calcutta" ? "yyyy-MM-dd" : "yyyy/MM/dd",
    );
  });
  const [showPassword, setShowPassword] = useState(false);
  const [addNearRegion, setAddNearRegion] = useState(false);
  const [nearbyRegionsList, setNearbyRegionsList] = useState({
    isLoading: false,
    list: [],
  });
  const [allRegionsLoaded, setAllRegionsLoaded] = useState(false);
  const [regions, setRegions] = useState([]);
  const [targetProfileId, setTargetProfileId] = useState<string>();
  const [targetRegionOption, setTargetRegionOption] = useState<any>(null);

  useEffect(() => {
    // Get specific query param
    const code = searchParams.get("code"); // e.g. ?user=123
    setCode(code);
  }, [searchParams]);

  useEffect(() => {
    const { id } = params;
    setId(id);
  }, [params]);
  useEffect(() => {
    const loadContractor = async () => {
      const data = await fetchContractor({ id: id, setLoader: setLoader });
      if (data) {
        setFieldValue("mobile_number", data?.mobile_number);
        setFieldValue("first_name", data?.first_name);
        setFieldValue("last_name", data?.last_name);
        setFieldValue("email", data?.email);
        if (data?.status === "active") {
          setIsContractorActive(true);
        }
      }
    };
    if (id) {
      loadContractor();
    }
  }, [id]);
  interface FormValues {
    username: string;
    mobile_number: string;
    password: string;
    first_name: string;
    last_name: string;
    email: string;
    date_of_birth: string;
    regionId: string; // Now stores city ID instead of city name
    state: string;
    referred_by: string;
    sms_opt_out: boolean;
    regions: any[];
  }

  const initialValues: FormValues = {
    username: "",
    referred_by: code,
    mobile_number: "",
    password: "",
    first_name: "",
    last_name: "",
    email: "",
    date_of_birth: defaultDob,
    regionId: "",
    state: "",
    sms_opt_out: true,
    regions: [],
  };

  const { errors, handleChange, handleSubmit, setFieldValue, values } =
    useFormik({
      initialValues: initialValues,
      enableReinitialize: true,
      validateOnChange: false,
      onSubmit: async (values) => {
        console.log("Values: ", values);
        if (addNearRegion && regions.length === 0) {
          toast.error("Please select at least one nearby region.");
          return;
        }
        setLoader(true);
        try {
          if (targetProfile) {
            setRegionIdMe(values.regionId);
            const result = await updateCleaner({
              ...values,
              username: undefined,
              password: undefined,
              id: targetProfileId || getUserDetails()?.user_id,
              onBoardingStatus: true,
            });
            if (result?.success) {
              setOnboardingStatus(true);
              navigate("/cleaner-profile", { replace: true });
            }
            return;
          }
          const result = await cleanerRegister({
            ...values,
            onBoardingStatus: true,
          });
          if (result) {
            const otpresult = await sendOTP({ username: result?.username });
            const loginresult = await login({
              username: values.username,
              password: values.password,
            });
            if (loginresult.success === true) {
              const data = {
                userType: loginresult?.data?.user.type,
                user_id: loginresult?.data?.auth.user_id,
              };
              localStorage.setItem("auth", JSON.stringify(data));

              persistToken(
                loginresult?.data?.auth.jwt,
                loginresult?.data?.auth?.onBoardingStatus ??
                  loginresult?.data?.onBoardingStatus
              );

              setRegionIdMe(loginresult?.data?.user?.regionId);
              if (id) {
                const contractorres = await updateContractor({
                  id: id,
                  cleaner_id: result?.id,
                  status: "active",
                });
              }
              const walletres = await CreateWallet({
                owner_id: loginresult?.data?.auth.user_id,
                owner_type: "CLEANER",
              });
              setLoader(false);
              navigate("/verify-otp");
            }
          } else {
            setLoader(false);
          }
        } catch (error) {
          setLoader(false);
        } finally {
          setLoader(false);
        }
      },
      validationSchema: targetProfile
        ? cleanerRegisterSchema.omit(["username", "password"])
        : cleanerRegisterSchema,
    });
  useEffect(() => {
    let isMounted = true;
    const loadTargetProfile = async () => {
      if (!targetProfile) return;
      const id = getUserDetails()?.user_id;
      if (!id) return;
      setTargetProfileId(id);
      setLoader(true);
      try {
        const response = await getCleaner(new URLSearchParams({ id }));
        const data = response?.data;
        if (!data || !isMounted) return;
        const userResponse = await getUserFullProfile();
        if (!isMounted) return;
        const sharedRegion = userResponse?.data?.regions?.[0]?.regionId;
        const rawRegionId = data.regionId || data.address?.regionId || sharedRegion;
        const regionId = typeof rawRegionId === "object"
          ? rawRegionId.id || rawRegionId._id
          : rawRegionId;
        if (regionId) setRegionIdMe(regionId);
        setTargetProfileId(data.id || data._id || id);
        setFieldValue("first_name", data.first_name || "");
        setFieldValue("last_name", data.last_name || "");
        setFieldValue("mobile_number", data.mobile_number || "");
        setFieldValue("email", data.email || "");
        setFieldValue("date_of_birth", data.date_of_birth || "");
        setFieldValue("regionId", regionId || "");
        setFieldValue("sms_opt_out", data.sms_opt_out ?? true);
        setFieldValue("referred_by", data.referred_by || "");
        setRegions(data.regions || []);
        if (sharedRegion?.id || sharedRegion?._id) {
          const id = sharedRegion.id || sharedRegion._id;
          setTargetRegionOption({
            id,
            city: sharedRegion.city,
            state: sharedRegion.state,
            coordinates: sharedRegion.coordinates,
          });
        } else if (regionId) {
          setTargetRegionOption(regionId);
        }
      } finally {
        if (isMounted) setLoader(false);
      }
    };
    loadTargetProfile();
    return () => {
      isMounted = false;
    };
  }, [targetProfile]);
  useEffect(() => {
    scrollToError(errors);
  }, [errors]);
  useEffect(() => {
    setFieldValue("regions", regions);
  }, [regions]);

  const referralHelpText = intl.formatMessage({
    id: "AUTH.INPUT.REFERRAL.HELP",
    defaultMessage: "If a friend invited you, enter their referral code here.",
  });

  const loadgetNearbyRegions = async (limit = 10) => {
    console.log("regionId", values?.regionId);
    setNearbyRegionsList({ ...nearbyRegionsList, isLoading: true });
    setTimeout(async () => {
      const getNearbyRegionsResult = await getNearbyRegions({
        ids: [values?.regionId],
        limit: limit,
      });
      console.log("getNearbyRegionsResult", getNearbyRegionsResult);
      const list = getNearbyRegionsResult?.data || [];

      setNearbyRegionsList({
        isLoading: false,
        list: list,
      });

      // Once we've asked for the "View All" ceiling, there's nothing more
      // to fetch — hide/disable regardless of count returned.
      setAllRegionsLoaded(limit >= 50 || list.length < limit);
    }, 100);
  };

  useEffect(() => {
    if (values?.regionId != undefined) {
      setNearbyRegionsList({
        ...nearbyRegionsList,
        isLoading: false,
        list: [],
      });
      setRegions([]);
      setAddNearRegion(false);
      setAllRegionsLoaded(false);
    }
  }, [values?.regionId]);

  return (
    <>
      <main>
        {loader && <LoaderFullScreen />}
        <div className="lg:container mx-auto lg:max-w-3xl lg:mt-24 mt-8 px-4 lg:px-0">
          {(id && isContractorActive === false) || !id ? (
            <div className="lg:flex-1 lg:flex flex-col h-fit lg:mx-12 mx-auto lg:p-6 p-4 bg-white border border-gray-border rounded-xl">
              <div className="flex justify-center">
                <Link to="/create-cleaner" className="z-50">
                  <img
                    width={150}
                    src={toAbsoluteUrl("/media/logos/logo2.png")}
                    alt=""
                    className="bg-white rounded-lg"
                  />
                </Link>
              </div>
              <h1 className=" text-xl mt-10">
                {targetProfile ? "Complete your profile" : <FormattedMessage id="ECOMMERCE.COMMON.CREATE_AN_ACCOUNT.TEXT" defaultMessage="Create an Account" />}
              </h1>
              <h3 className="text-md">As a Cleaner</h3>
              <div className="w-full">
                <form onSubmit={handleSubmit}>
                  <Input
                    onChange={handleChange}
                    label={renderRequiredLabel(
                      intl.formatMessage({
                        id: "AUTH.INPUT.FIRSTNAME",
                        defaultMessage: "First Name",
                      }),
                    )}
                    placeholder={intl.formatMessage({
                      id: "AUTH.INPUT.FIRSTNAME.PLACEHOLDER",
                      defaultMessage: "Enter your first name",
                    })}
                    type={"text"}
                    name="first_name"
                    error={errors.first_name}
                    value={values.first_name}
                  ></Input>
                  <Input
                    onChange={handleChange}
                    label={renderRequiredLabel(
                      intl.formatMessage({
                        id: "AUTH.INPUT.LASTNAME",
                        defaultMessage: "Last Name",
                      }),
                    )}
                    placeholder={"Enter your last name"}
                    type={"text"}
                    name="last_name"
                    error={errors.last_name}
                    value={values.last_name}
                  ></Input>
                  {!targetProfile && <Input
                    onChange={handleChange}
                    name="username"
                    label={renderRequiredLabel(
                      intl.formatMessage({
                        id: "AUTH.INPUT.USERNAME",
                        defaultMessage: "Username",
                      }),
                    )}
                    placeholder={intl.formatMessage({
                      id: "AUTH.INPUT.USERNAME.PLACEHOLDER",
                      defaultMessage: "Enter your username",
                    })}
                    type={"text"}
                    error={errors.username}
                    value={values.username}
                  ></Input>}

                  {!targetProfile && <div className="relative">
                    <Input
                      onChange={handleChange}
                      label={renderRequiredLabel(
                        intl.formatMessage({
                          id: "AUTH.INPUT.PASSWORD",
                          defaultMessage: "Password",
                        }),
                      )}
                      placeholder={intl.formatMessage({
                        id: "AUTH.INPUT.PASSWORD.PLACEHOLDER",
                        defaultMessage: "Enter your password",
                      })}
                      type={showPassword ? "text" : "password"}
                      name="password"
                      error={errors.password}
                    />

                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-9 cursor-pointer text-gray-600"
                    >
                      <FontAwesomeIcon
                        icon={showPassword ? faEye : faEyeSlash}
                      />
                    </span>
                  </div>}
                  <Input
                    onChange={handleChange}
                    label={renderRequiredLabel(
                      intl.formatMessage({
                        id: "AUTH.INPUT.MOBILENO",
                        defaultMessage: "Mobile Number",
                      }),
                    )}
                    placeholder={intl.formatMessage({
                      id: "AUTH.INPUT.LASTMOBILENONAME.PLACEHOLDER",
                      defaultMessage: "Enter your Mobile Number",
                    })}
                    type={"tel"}
                    name="mobile_number"
                    error={errors.mobile_number}
                    value={InputNumberFormat(values.mobile_number)}
                  ></Input>
                  <Input
                    onChange={handleChange}
                    label={renderRequiredLabel(
                      intl.formatMessage({
                        id: "AUTH.INPUT.EMAIL.ADDRESS",
                        defaultMessage: "Email Address",
                      }),
                    )}
                    placeholder={intl.formatMessage({
                      id: "AUTH.INPUT.EMAIL.PLACEHOLDER",
                      defaultMessage: "Enter your email id",
                    })}
                    type={"email"}
                    name="email"
                    value={values.email}
                    error={errors.email}
                    readOnly={targetProfile}
                  ></Input>
                  <SmartSearchSelect
                    value={values?.regionId}
                    onChange={(value) => setFieldValue("regionId", value)}
                    label={intl.formatMessage({
                      id: "INPUT.VALIDATION.REGION",
                      defaultMessage: "Region",
                    })}
                    options={targetProfile && targetRegionOption ? [targetRegionOption] : []}
                    required={true}
                    error={errors.regionId}
                    placeholder="Search for a Region..."
                  />
                  <div className="flex flex-col gap-2">
                    <div className="">
                      <p className="mt-10 mb-1 text-gray-700 text-sm ">
                        <FormattedMessage
                          id="AUTH.INPUT.NEARBYREGION.TITLE"
                          defaultMessage="Do you want to add a nearby region?"
                        />
                      </p>
                      <div className="flex space-x-6">
                        <RadioInput
                          name="Yes"
                          value={true}
                          label={
                            <FormattedMessage
                              id="AUTH.INPUT.NEARBYREGION.NOW"
                              defaultMessage="Now"
                            />
                          }
                          checked={addNearRegion}
                          onChange={async () => {
                            if (values?.regionId) {
                              setAddNearRegion(true);
                              await loadgetNearbyRegions();
                            } else {
                              setAddNearRegion(false);
                              toast.error("Please select a region first");
                            }
                          }}
                        />
                        <RadioInput
                          name="No"
                          value={false}
                          label={
                            <FormattedMessage
                              id="AUTH.INPUT.NEARBYREGION.LATER"
                              defaultMessage="Do it later"
                            />
                          }
                          checked={addNearRegion === false}
                          onChange={() => {
                            setAddNearRegion(false);
                            setRegions([]);
                          }}
                        />
                      </div>
                    </div>
                    {addNearRegion === true && (
                      <div className="border border-gray-300 rounded-md p-4 bg-gray-50">
                        <div className="max-h-40 grid grid-cols-2 gap-2 overflow-y-auto">
                          {nearbyRegionsList.isLoading == true ? (
                            <div className="flex items-center justify-center rounded-md px-2 py-1 col-span-3">
                              <span className="text-sm text-gray-700">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            nearbyRegionsList.list?.map((item, index) => (
                              <div
                                key={index}
                                className="flex items-center justify-between rounded-md border border-gray-border px-2 py-1"
                              >
                                <Checkbox
                                  labelClass="font-normal"
                                  key={index}
                                  checked={regions.includes(item.id)}
                                  label={`${item?.city} (${item?.state}), ${item?.distanceMiles} mi`}
                                  id={item.id}
                                  // name={data.value}
                                  value={item.id}
                                  onChange={(e) => {
                                    CheckBoxHandle(e, regions, setRegions);
                                  }}
                                />
                              </div>
                            ))
                          )}
                        </div>
                        <div className="mt-2 flex justify-center">
                          <button
                            type="button"
                            disabled={allRegionsLoaded}
                            onClick={async () => {
                              if (allRegionsLoaded) {
                                toast.info(
                                  "You've already loaded all nearby regions",
                                );
                                return;
                              }
                              if (values?.regionId) {
                                await loadgetNearbyRegions(50);
                              }
                            }}
                            className={`ring-1 rounded px-2 py-1 focus:outline-none focus:shadow-outline ${
                              allRegionsLoaded
                                ? "text-gray-400 ring-gray-300 cursor-not-allowed"
                                : "text-blue-500 hover:text-blue-700"
                            }`}
                          >
                            <FormattedMessage
                              id="AUTH.INPUT.NEARBYREGION.VIEWALL"
                              defaultMessage="View All"
                            />
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <ReactDatePicker
                    open={false}
                    onChange={(date) => setFieldValue("date_of_birth", date)}
                    selected={values.date_of_birth}
                    isDefaultSelected={false}
                    label={
                      <span className="inline-flex items-center gap-1">
                        {renderRequiredLabel(
                          intl.formatMessage({
                            id: "AUTH.INPUT.DATEOFBIRTH",
                            defaultMessage: "Date of Birth",
                          }),
                        )}
                        <span
                          className="group relative inline-flex h-4 w-4 cursor-help items-center justify-center rounded-full border border-gray-300 text-[10px] font-medium leading-none text-gray-400"
                          aria-label={dobHelpText}
                          tabIndex={0}
                        >
                          ?
                          <span className="pointer-events-none absolute left-full top-1/2 z-10 ml-2 w-48 origin-left -translate-y-1/2 scale-0 rounded bg-gray-800 px-2 py-1 text-[11px] font-normal leading-relaxed text-white shadow-sm transition-transform duration-150 group-hover:scale-100 group-focus:scale-100">
                            {dobHelpText}
                          </span>
                        </span>
                      </span>
                    }
                    error={errors.date_of_birth}
                  ></ReactDatePicker>

                  <div className="mt-6 border border-gray-300 rounded-md p-4 bg-gray-50">
                    <p className="font-semibold text-sm mb-3">
                      {renderRequiredLabel("SMS Opt-In Agreement")}
                    </p>

                    <div className="space-y-2">
                      <RadioInput
                        name="sms_opt_out"
                        value={false}
                        label="Yes, I would like to receive SMS"
                        checked={values.sms_opt_out === false}
                        onChange={() => setFieldValue("sms_opt_out", false)}
                      />

                      <RadioInput
                        name="sms_opt_out"
                        value={true}
                        label="No, I would not like to receive SMS"
                        checked={values.sms_opt_out === true}
                        onChange={() => setFieldValue("sms_opt_out", true)}
                      />
                    </div>

                    <p className="text-xs text-gray-500 mt-3 leading-relaxed">
                      By opting in, you will receive 1 or more text messages per
                      month related to new job postings, job & work order
                      updates, hiring status, and more. You can update this
                      later in your account settings. Message and data rates may
                      apply. Reply STOP to unsubscribe or HELP for help.{" "}
                      <a
                        href="https://janijobs.com/privacy-policy/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline"
                      >
                        Privacy Policy
                      </a>{" "}
                      and{" "}
                      <a
                        href="https://support.janijobs.com/hc/en-us/articles/42346401405723-JaniJobs-Global-Terms-and-Conditions"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline"
                      >
                        Terms and Conditions
                      </a>{" "}
                      apply.
                    </p>

                    {errors?.sms_opt_out && (
                      <p className="mt-1 text-red-400 md:text-sm sm:text-[.65rem]">
                        Please select Text Message opt out option
                      </p>
                    )}
                  </div>

                  <Input
                    onChange={handleChange}
                    label={
                      <span className="inline-flex items-center gap-1">
                        {intl.formatMessage({
                          id: "AUTH.INPUT.REFER.ADDRESS",
                          defaultMessage: "Referral Code",
                        })}
                        <span
                          className="group relative inline-flex h-4 w-4 cursor-help items-center justify-center rounded-full border border-gray-300 text-[10px] font-medium leading-none text-gray-400"
                          aria-label={referralHelpText}
                          tabIndex={0}
                        >
                          ?
                          <span className="pointer-events-none absolute left-full top-1/2 z-10 ml-2 w-48 origin-left -translate-y-1/2 scale-0 rounded bg-gray-800 px-2 py-1 text-[11px] font-normal leading-relaxed text-white shadow-sm transition-transform duration-150 group-hover:scale-100 group-focus:scale-100">
                            {referralHelpText}
                          </span>
                        </span>
                      </span>
                    }
                    placeholder={intl.formatMessage({
                      id: "AUTH.INPUT.REFER.LABEL.PLACEHOLDER",
                      defaultMessage: "Enter Referral Code",
                    })}
                    type="text"
                    name="referred_by"
                    value={values.referred_by}
                    error={errors.referred_by}
                  />

                  {/* <Link to="/verify-otp" replace> */}
                  <div className="flex justify-center">
                    <ButtonAuth
                      loader={loader}
                      onClick={() => {
                        if (!targetProfile) localStorage.setItem("RegisterAs", "Cleaner");
                      }}
                    >
                      {targetProfile ? "Continue" : <FormattedMessage id="AUTH.GENERAL.CREATE.ACCOUNT.BUTTON" defaultMessage="Create Account" />}
                    </ButtonAuth>
                  </div>
                  {/* </Link> */}
                </form>
                {!targetProfile && <div className="mt-10 space-x-1 flex justify-center">
                  <span>
                    <FormattedMessage
                      id="AUTH.ALREADY.HAVE.ACCOUNT"
                      defaultMessage="Already have an account?"
                    />
                  </span>
                  <Link
                    to="/auth"
                    className="cursor-pointer hover:text-pink underline"
                    replace
                  >
                    <FormattedMessage
                      id="AUTH.SIGN_IN_HERE"
                      defaultMessage="Sign in here"
                    />
                  </Link>
                </div>}
              </div>
            </div>
          ) : (
            <div className="lg:flex-1 lg:flex block w-full flex-col h-fit lg:mx-12 mx-auto lg:p-6  px-4 py-4 bg-white border border-gray-border rounded-xl">
              <p>You have already registered </p>
            </div>
          )}
        </div>
      </main>
    </>
  );
}
